import React, { useState, useEffect } from 'react';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'false');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 border-t-2 border-customRed bg-customGray text-customRed p-4 flex flex-col md:flex-row justify-between items-center">
      <p className="flex-grow">
        Questo sito utilizza i cookie per migliorare l'esperienza utente. Continuando a navigare, accetti l'uso dei cookie.
      </p>
      <div className="flex space-x-4 mt-3 mr-20">
        <button onClick={handleAccept} className="bg-customRed hover:bg-customRed text-white font-bold py-2 px-4 rounded">
          Accetta
        </button>
        <button onClick={handleReject} className="bg-customRed  hover:bg-customRed text-white font-bold py-2 px-4 rounded">
          Rifiuta
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
